import styled from 'styled-components';
import { themeGet } from 'styled-system';

const Rect = styled.rect`
  fill: ${({ fill }) => themeGet(`colors.${fill}`, fill)};
  stroke: ${({ stroke }) => themeGet(`colors.${stroke}`, stroke)};
`;

export default Rect;
